var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h4',{staticClass:"alert alert-danger"},[_vm._v("\n    You are not authorized to edit or add data to TerraTrac. Please contact your IT administrator\n    if you believe you should have access to this functionality.\n  ")])])
}]

export { render, staticRenderFns }